module.exports = __webpack_public_path__ + "static/media/Item_Head_G_00_Lv3_C.2d889be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Headgear/Item_Head_G_00_Lv3_C.png
// module id = 197
// module chunks = 0